'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isApiBlackListed = exports.isApiBlackListed = function isApiBlackListed() {
  return window.location.href.indexOf('sales-iframes') !== -1 || window.location.origin === 'https://preview.hs-sites.com' || window.location.origin === 'https://preview.hs-sitesqa.com';
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/navigation/isApiBlackListed.js
// module id = 495
// module chunks = 3 4 5